import * as React from 'react'
import * as Common from '@tfo/common'
import { inject, observer } from 'mobx-react'
import { injectIntl } from 'react-intl'
import { useHistory, useParams } from 'react-router-dom'
import './NewReportStart.scss'
import { Grid } from '@tfo/common'
import ReportCard from './components/report-card/ReportCard'
import AboutReportModal from '../../../../components/modals/about-report-modal/AboutReportModal'
import RootStore from '../../../../stores/RootStore'

export interface NewReportStartProps {
	rootStore?: RootStore
}
const NewReportStart = (props: any) => {
	const { companyId } = useParams<{ companyId: string }>()
	const store = props.rootStore!.clientViewStore!
	const history = useHistory()
	const [reportPackages, setReportPackages] = React.useState<Array<Common.models.ReportPackage>>()

	React.useEffect(() => {
		if (companyId && history.location.pathname.includes('/service-packages')) {
			getReportPackages(parseInt(companyId))
		}
	}, [companyId])


	const getReportPackages = async (companyId: number) => {
		store.loading = true
		await store.getReportPackageBySubsidiaries(companyId)
		setReportPackages(() => [...store.activeReportPackages])
		store.loading = false
	}

	const onClickCard = async (data: Common.models.ReportPackage) => {
		store.selectedReportPackage = data
		store.modalOpen = false
		history.push(`/new-report-order/${data.companyId}/${data.id}`)
	}

	const onClickCardDetails = (data: Common.models.ReportPackage) => {
		store.selectedReportPackage = data
		store.modalOpen = true
	}

	return (
		<React.Fragment>
			<Grid.GridWrapper className="ClientView ClientView--lessTopMargin NewReportStart NewReportStart__ReportCards">
				{reportPackages &&
					reportPackages.map(
						(service: Common.models.ReportPackage, index: number) => {
							return (
								<ReportCard
									key={index}
									data={service}
									proceedToOrderCallback={onClickCard}
									openDetailsCallback={onClickCardDetails}
								/>
							)
						},
					)}
			</Grid.GridWrapper>
			{store.modalOpen && (
				<AboutReportModal
					data={store.selectedReportPackage}
					onCloseClick={() => store.toggleModal()}
				/>
			)}
		</React.Fragment>
	)
}

export default injectIntl(inject('rootStore')(observer(NewReportStart)))
